export default __webpack_public_path__ + "static/Spud-3d8e02cad9d7a18b93d4b4cb0c6904de.jpg";